import React from "react";

function IconFacebook(data) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={data.w}
        height={data.h}
        viewBox="0 0 5 16"
      >
        <text fontFamily="Helvetica" fontSize="16" transform="translate(0 12)">
          <tspan x="0" y="0">
            f
          </tspan>
        </text>
      </svg>
    );
}

export default IconFacebook;
